import { Button as MuiButton } from '@carto/meridian-ds/components'
import { OpenInNewOutlined } from '@mui/icons-material'
import { ButtonProps } from '@mui/material/Button'
import Link, { LinkProps } from '@mui/material/Link'
import { styled } from '@mui/material/styles'
import { externalLinkProps } from '../utils/navigationUtils'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const InlineLink = styled(Link)<{ fontWeight?: any }>(({ fontWeight = 500 }) => ({
  display: 'inline',
  fontWeight: fontWeight
}))

const IconOpenInNewOutlined = styled(OpenInNewOutlined)(() => ({
  display: 'inline',
  fontSize: '1em',
  // in some place, like alerts all svg/icon colors are overriden, so force color to link color
  color: `inherit !important`,
  '> path': {
    color: 'inherit !important'
  }
}))

const IconWrapperInline = styled('span')(() => ({
  marginLeft: '0.25em',
  position: 'relative',
  top: 'calc(1em * 5.0/32)' // heuristic to align icon with true perceived baseline
}))

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Button: any = styled(MuiButton)(({ size, theme }) => ({
  '& > span': {
    display: 'inline-flex',
    alignItems: 'center'
  },
  ...(size === 'small' && {
    svg: {
      width: `${theme.spacing(2)} !important`,
      height: `${theme.spacing(2)} !important`
    }
  })
}))

export function ExternalLink({
  children,
  showIcon = true,
  useButton = false,
  icon = <IconOpenInNewOutlined />,
  ...props
}: (LinkProps | ButtonProps) & { showIcon?: boolean; useButton?: boolean; icon?: JSX.Element }) {
  if (useButton) {
    return (
      <Button {...externalLinkProps} endIcon={showIcon && icon} {...(props as ButtonProps)}>
        {children}
      </Button>
    )
  } else {
    return (
      <InlineLink {...externalLinkProps} {...(props as LinkProps)}>
        {children}
        {showIcon && <IconWrapperInline>{icon}</IconWrapperInline>}
      </InlineLink>
    )
  }
}
